function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useEffect, useState, useRef } from 'react';
import { findDOMNode } from 'react-dom';
import Button from "./Button";
import Dropdown from "./Dropdown";
import DropdownItem from "./DropdownItem";
import DropdownMenu from "./DropdownMenu";
import DropdownToggle from "./DropdownToggle";
import Icon from "./Icon";
import Input from "./Input";
import InputGroup from "./InputGroup";
import InputGroupAddon from "./InputGroupAddon";
var defaultProps = {
  noResultsLabel: 'No results found',
  onChange: function onChange() {},
  filterOptions: function filterOptions(o, v) {
    return o.filter(function (option) {
      return v ? option.label.toLowerCase().indexOf(v.toLowerCase()) > -1 : true;
    });
  },
  renderInputValue: function renderInputValue(option) {
    return option.label;
  },
  renderOption: function renderOption(option) {
    return option.label;
  }
};

var Combobox = function Combobox(_ref) {
  var className = _ref.className,
      direction = _ref.direction,
      disabled = _ref.disabled,
      dropdownProps = _ref.dropdownProps,
      inputClassName = _ref.inputClassName,
      options = _ref.options,
      placeholder = _ref.placeholder,
      value = _ref.value,
      menuMaxHeight = _ref.menuMaxHeight,
      _ref$noResultsLabel = _ref.noResultsLabel,
      noResultsLabel = _ref$noResultsLabel === void 0 ? defaultProps.noResultsLabel : _ref$noResultsLabel,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? defaultProps.onChange : _ref$onChange,
      _ref$filterOptions = _ref.filterOptions,
      filterOptions = _ref$filterOptions === void 0 ? defaultProps.filterOptions : _ref$filterOptions,
      _ref$renderInputValue = _ref.renderInputValue,
      renderInputValue = _ref$renderInputValue === void 0 ? defaultProps.renderInputValue : _ref$renderInputValue,
      _ref$renderOption = _ref.renderOption,
      renderOption = _ref$renderOption === void 0 ? defaultProps.renderOption : _ref$renderOption,
      props = _objectWithoutProperties(_ref, ["className", "direction", "disabled", "dropdownProps", "inputClassName", "options", "placeholder", "value", "menuMaxHeight", "noResultsLabel", "onChange", "filterOptions", "renderInputValue", "renderOption"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      visibleOptions = _useState6[0],
      setVisibleOptions = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      focusedOptionIndex = _useState8[0],
      setFocusedOptionIndex = _useState8[1];

  var inputElement = useRef(null);
  var dropdownMenu = useRef(null);
  var focusedOption = useRef(null);
  var selectedOption = options.find(function (option) {
    return option.value === value;
  });
  useEffect(function () {
    if (visibleOptions.length > 0) {
      setFocusedOptionIndex(0);
    }
  }, [visibleOptions]);
  useEffect(function () {
    setInputValue('');
  }, [selectedOption, open]);
  useEffect(function () {
    if (!open && inputElement.current) inputElement.current.blur();
  }, [open]);
  useEffect(function () {
    setVisibleOptions(filterOptions(options, inputValue));
  }, [inputValue, setVisibleOptions, filterOptions, options]);

  var scrollFocusedOptionIntoView = function scrollFocusedOptionIntoView() {
    if (dropdownMenu.current === null || focusedOption.current === null) return;
    /* eslint-disable react/no-find-dom-node */

    var focusedOptionNode = findDOMNode(focusedOption.current);
    var menuNode = findDOMNode(dropdownMenu.current);
    /* eslint-enable react/no-find-dom-node */

    if (focusedOptionNode === null || menuNode === null) return;
    var scrollTop = menuNode.scrollTop;
    var scrollBottom = scrollTop + menuNode.offsetHeight;
    var optionTop = focusedOptionNode.offsetTop;
    var optionBottom = optionTop + focusedOptionNode.offsetHeight;

    if (scrollTop > optionTop) {
      menuNode.scrollTop -= focusedOptionNode.offsetHeight;
    } else if (scrollBottom < optionBottom) {
      menuNode.scrollTop += focusedOptionNode.offsetHeight;
    }
  };

  useEffect(scrollFocusedOptionIntoView, [focusedOptionIndex]);

  var selectOption = function selectOption(option) {
    onChange(option.value);
    setOpen(false);
  };

  var handleOptionsKeyboardNav = function handleOptionsKeyboardNav(_ref2) {
    var key = _ref2.key;

    if (!open && key === 'ArrowDown') {
      setOpen(true);
    } else if (key === 'Enter') {
      selectOption(visibleOptions[focusedOptionIndex]);
    } else if (key === 'ArrowDown' && focusedOptionIndex < visibleOptions.length - 1) {
      setFocusedOptionIndex(focusedOptionIndex + 1);
    } else if (key === 'ArrowUp' && focusedOptionIndex > 0) {
      setFocusedOptionIndex(focusedOptionIndex - 1);
    } else if (selectedOption && key === 'Backspace' && inputValue === '') {
      onChange(undefined);
    }
  };

  return (
    /*#__PURE__*/
    React.createElement(Dropdown, {
      direction: direction,
      isOpen: !disabled && open,
      toggle: function toggle() {},
      onBlur: function onBlur() {
        setOpen(false);
      }
    },
    /*#__PURE__*/
    React.createElement(DropdownToggle, {
      tag: "div",
      disabled: disabled
    }, selectedOption && inputValue === '' &&
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React.createElement("div", {
      "aria-label": "Selected value",
      className: "py-2 px-3",
      style: {
        position: 'absolute',
        width: 'calc(100% - 1.5rem)',
        zIndex: 4,
        left: 1
      },
      onMouseDown: function onMouseDown(ev) {
        ev.preventDefault();
        if (inputElement.current) inputElement.current.focus();
      }
    }, selectedOption && renderInputValue(selectedOption)),
    /*#__PURE__*/
    React.createElement(InputGroup, {
      className: className
    },
    /*#__PURE__*/
    React.createElement(Input, _extends({
      innerRef: inputElement,
      "data-testid": "combobox-input",
      disabled: disabled,
      className: inputClassName,
      placeholder: selectedOption ? undefined : placeholder,
      onFocus: function onFocus(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        setOpen(true);
      },
      onChange: function onChange(e) {
        e.preventDefault();
        e.stopPropagation();
        setInputValue(e.target.value);
      },
      onKeyDown: handleOptionsKeyboardNav,
      type: "search",
      value: inputValue
    }, props)),
    /*#__PURE__*/
    React.createElement(InputGroupAddon, {
      addonType: "append"
    },
    /*#__PURE__*/
    React.createElement(Button, {
      className: "px-2",
      "data-testid": "combobox-caret",
      disabled: disabled,
      active: open,
      onMouseDown: function onMouseDown(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        setOpen(!open);
      },
      type: "button",
      tabIndex: -1
    },
    /*#__PURE__*/
    React.createElement(Icon, {
      name: open ? 'caret-up' : 'caret-down',
      fixedWidth: true
    }))))),
    /*#__PURE__*/
    React.createElement(DropdownMenu, _extends({
      "data-testid": "combobox-menu",
      className: "p-0 w-100",
      modifiers: {
        setMaxHeight: {
          enabled: true,
          fn: function fn(data) {
            return _objectSpread(_objectSpread({}, data), {}, {
              styles: _objectSpread(_objectSpread({}, data.styles), {}, {
                overflowY: 'auto',
                maxHeight: menuMaxHeight || '12rem'
              })
            });
          }
        }
      }
    }, dropdownProps, {
      ref: dropdownMenu
    }), visibleOptions.map(function (option, i) {
      return (
        /*#__PURE__*/
        React.createElement(DropdownItem, {
          disabled: option.disabled,
          key: option.value,
          active: focusedOptionIndex === i,
          onMouseEnter: function onMouseEnter(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            setFocusedOptionIndex(i);
          },
          onMouseDown: function onMouseDown(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            selectOption(option);
          },
          ref: i === focusedOptionIndex ? focusedOption : null
        }, renderOption(option))
      );
    }), visibleOptions.length === 0 &&
    /*#__PURE__*/
    React.createElement(DropdownItem, {
      disabled: true
    }, noResultsLabel)))
  );
};

Combobox.displayName = "Combobox";
Combobox.displayName = 'Combobox';
Combobox.defaultProps = defaultProps;
export default Combobox;